import { render, staticRenderFns } from "./uniOffers.vue?vue&type=template&id=be8ba194&"
import script from "./uniOffers.vue?vue&type=script&lang=js&"
export * from "./uniOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be8ba194')) {
      api.createRecord('be8ba194', component.options)
    } else {
      api.reload('be8ba194', component.options)
    }
    module.hot.accept("./uniOffers.vue?vue&type=template&id=be8ba194&", function () {
      api.rerender('be8ba194', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27h8jJt44N02G/JS/uniOffers.vue"
export default component.exports